"use strict";
//########################################
// index.js KAV Baden Württemberg Survey Client
//########################################
// injected code start
// do not modify this line or the following lines until the closing comment ("// injected code end")
// instead modify const IndexJsInitializeCode in ../SurveyClient.Shared/default-code.js
import $ from 'jquery';
window.$ = window.jQuery = $; // export for other scripts to use
// eslint-disable-next-line no-unused-vars
import config from 'devextreme/core/config';
import DevExpress from "devextreme/bundles/modules/core";
import ui from "devextreme/bundles/modules/ui";
DevExpress.ui = ui;
import {confirm, alert } from "devextreme/ui/dialog";
DevExpress.ui.dialog = {};
DevExpress.ui.dialog.confirm = confirm;
DevExpress.ui.dialog.alert = alert;
import notify from "devextreme/ui/notify"
DevExpress.ui.notify = notify;
import 'devextreme/integration/jquery';
import "devextreme/ui/popup";
import "devextreme/ui/form";
import "devextreme/ui/button";
import "devextreme/ui/drop_down_box";
import "devextreme/ui/data_grid";
import "devextreme/ui/select_box";
import "devextreme/ui/date_box";
import "devextreme/ui/text_area";
import "devextreme/ui/scroll_view";
import "devextreme/ui/toast";
import "devextreme/ui/tooltip";
import "devextreme/localization";

import '../../../../../KAV Common/Clients/SurveyClient.Shared/devextreme-license'; 
import * as SurveyTools from '../../../../../KAV Common/Clients/SurveyClient.Shared/surveyTools.js';
window.SurveyTools = SurveyTools;
import * as SurveyPdf from '../../../../../KAV Common/Clients/SurveyClient.Shared/pdfExport.js';
window.SurveyPdf = SurveyPdf;
import { jsPDF } from "jspdf";
window.jsPDF = jsPDF;
import { exportDataGrid } from "devextreme/pdf_exporter"
window.exportDataGrid = exportDataGrid;
SurveyTools.InitDevextremeTexts();
window.Messages = SurveyTools.Messages;

// Konfiguration, die %XX% werden beim Build mit den richtigen Werten ersetzt
// Anpassungen in customize.Initialize() vornehmen
window.CONFIG = {
    clientVersion: "1.0.1",     // Version des Clients
    clientSharedVersion: "1.6.3",   // Version shared code Client
    serverApi: 'https://api.kavbw.de/kav/api/v1/survey',              // URL des Webservice
    clientBaseUrl: 'https://api.kavbw.de/personalbestandserhebung',          // Root-Adresse des Clients
    buildMode: 'production',              // Production | Development
    home: "https://www.kavbw.de/",                     // URL der Homepage
    customer: "KAV Baden-Württemberg e.V.",                 // Bezeichnung des KAV
    customerShort: "KAV Baden-Württemberg",      // Kurzform derBezeichnung des KAV
    authHeader: "X-KAV-SessionId",          // Name des Headers
    specialLogin: null,                     // "neu", wenn extraLogin
    customHeaders: {},                      // Standard-Header für Requests, der Authentication-Header (Name: Wert von CONFIG.authHeader) wird automatisch eingefügt
    useExtraordinarySurvey: false,          // außerordentliche Erhebung (für Neumitglieder, außerhalb des regulären Zeitraums) verwenden?
    pathExtraordinarySurvey: '/neumitglied',// Pfad zum Login für die außerordentliche Erhebung
    useIntegratedLogin: true,               // eingebautes Login verwenden, wenn false, dann muß (über customize.Initialize()) AuthenticationHandler(pfadAusURL, FortsetzungsFunktion) bereitgestellt werden, siehe dort
    smallSurveyForGuests: false,            // true: für Gastmitglieder nur die Gesamtzahlen Beschäftigte / Azubis abfragen
    useStandardHeader: true,                // true: Header erzeugen
    useStandardFooter: true,                // true: Footer erzeugen
    askIfZero: true,                        // true: Rückfragen, ob 0 Mitarbeiter auch so gemeint sind
    showSaveAndLogoutButton: true,          // true: Button "Speichern & Logout" anzeigen
    useNoEmployees: true,                   // true: Checkbox "Keine Beschäftigten" anzeigen und von der Standard-Implementierung steuern lassen.
    personResponsible: {
        maxLength: 60
    },
    email: {
        maxLength: 150
    },
    telefon: {
        maxLength: 35
    },
    deviationReason: {
        maxLength: 150,
        acceptCustomValue: true,
        items: []
    },
    deviationCheck: {
     tagEditors: true,
     tagSums: true
    }
};
import * as Customize from "./customize.js"
window.Customize = Customize;
// injected code end

// Standard-Implementierung laden. Anstelle dessen könnte hier auch eine alternative Implementierung geladen werden (deshalb wird dieser Code auch nicht oben injiziert)
// Eine alternative Implementierung muß dieselben Funktionen exportieren wie survey.js
import * as Survey from '../../../../../KAV Common/Clients/SurveyClient.Shared/survey.js'; 
window.Survey = Survey;
// Generierter Code mit Helfern für die eigentliche Erhebungtabelle
// Der Name der js Datei ist konfigurierbar, deshalb wird dieser Code nicht oben injiziert
import * as surveyHelper from './generated_erhebung_support.js';
CONFIG.surveyHelper = surveyHelper;

// Hier ggf. weitere Module laden und bekanntgeben

// Los geht's, hier nichts ändern (=> customize.initialize)
$(function () {
    SurveyTools.run(); // That's all, folks
});
